<template>
  <header
    ref="desktopMenu"
    class="CorporateHeader header sticky top-0 w-full z-header"
  >
    <!-- mobile -->
    <div
      class="desk:hidden h-[52px]
        bg-lightest shadow-bottomLine
        flex justify-between items-center
      "
    >
      <div class="flex-1 flex flex-row justify-start items-center gap-12">
        <div class="pl-12">
          <button
            class="w-24 h-24 flex items-center"
            :title="$t('header.menu.open')"
            type="button"
            @click="openMenu"
          >
            <img
              src="/icons/menu.svg"
              class="w-24 h-24"
              :alt="$t('header.menu')"
            >
          </button>
        </div>
      </div>
      <nuxt-link :to="homeUrl()" class="absolute top-0 left-half -translate-x-half w-[58px]">
        <img
          :src="`/logos/${globalContent.domainMap?.logoUrl}.svg`"
          class="w-full h-auto"
          alt="logo"
        >
      </nuxt-link>
      <div class="flex-1 pr-12 flex justify-end">
        <CorpLangSelector />
      </div>
    </div>

    <!-- desktop -->
    <div
      class="hidden desk:block
             h-[53px] w-full
             bg-lightest shadow-bottomLine
             relative z-modalsContent type-sm leading-single"
    >
      <div class="layout-container">
        <div class="w-full h-[53px] flex justify-between items-center relative">
          <nuxt-link :to="homeUrl()" class="w-[59px] absolute left-[calc(50%-30px)]">
            <img
              :src="`/logos/${globalContent.domainMap?.logoUrl}.svg`"
              class="w-full h-auto"
              alt="logo"
            >
          </nuxt-link>

          <!-- * * * left side -->
          <div class="pl-24">
            <div class="flex items-center justify-start">
              <div
                v-for="link in mainNavigation"
                :key="link._uid"
                class="desk:mr-12 deskStd:mr-20 last-of-type:mr-0"
              >
                <button
                  v-if="link.children.length > 0"
                  class="flex items-center h-[53px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
                  :class="{
                    'border-darkest text-text-base': uiStore.isParentOfOpenMenu(link._uid),
                  }"
                  type="button"
                  @click="clickMenuDesktop($sbLinkFix(link.link), (link.children.length > 0), link._uid, true)"
                >
                  <span
                    :class="{
                      'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                      'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
                    }"
                  >{{ link.title }}</span>
                </button>
                <nuxt-link
                  v-else-if="$sbLinkCheck(link.link)"
                  :to="$sbLinkFix(link.link)"
                  :target="$sbLinkTarget(link.link)"
                  class="flex items-center h-[53px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
                  :class="{
                    'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                    'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'), }"
                >
                  {{ link.title }}
                </nuxt-link>
              </div>
            </div>

          </div>

          <!-- * * * right side -->
          <div class="pr-24 flex items-center justify-end">

            <div
              v-for="link in secondaryNavigation"
              :key="link._uid"
              class="desk:mr-12 deskStd:mr-20 last-of-type:mr-0"
            >
              <button
                v-if="link.children.length > 0"
                class="flex items-center h-[53px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
                :class="{
                  'border-darkest text-text-base': uiStore.isParentOfOpenMenu(link._uid),
                }"
                type="button"
                @click="clickMenuDesktop($sbLinkFix(link.link), (link.children.length > 0), link._uid)"
              >
                <span
                  :class="{
                    'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                    'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
                  }"
                >{{ link.title }}</span>
              </button>
              <nuxt-link
                v-else-if="$sbLinkCheck(link.link)"
                :to="$sbLinkFix(link.link)"
                :target="$sbLinkTarget(link.link)"
                class="flex items-center h-[53px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
                :class="{
                  'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                  'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
                }"
              >
                {{ link.title }}
              </nuxt-link>
            </div>

            <CorpLangSelector/>
          </div>

        </div>
      </div></div>

    <div class="relative w-full">
      <DesktopMenuExpanded />
    </div>
  </header>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { useGlobalContentStore } from '~/store/globalContent';
import useLinkReplacer from '~/composables/useLinkReplacer';
import CorpLangSelector from '~/components/menu/CorpLangSelector.vue';
import useMenuHelper from '~/composables/useMenuHelper';
import DesktopMenuExpanded from '~/components/menu/DesktopMenuExpanded.vue';
import { onClickOutside } from '@vueuse/core';

const globalContent = useGlobalContentStore();
const uiStore = useUiStore();
const { homeUrl } = useLinkReplacer();

const mainNavigation = globalContent.getNavigation('mainNavigation');
const secondaryNavigation = globalContent.getNavigation('secondaryNavigation');
const { checkDesign, clickMenuDesktop } = useMenuHelper();

const openMenu = () => {
  uiStore.sideMenuParents = [];
  uiStore.setShowSideMenu(true);
};

const desktopMenu = ref<HTMLElement>();

onClickOutside(desktopMenu, () => {
  uiStore.closeDesktopMenu();
});
</script>
